"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiMenu = void 0;
var shape_1 = require("../../../theme/global/shape");
var palette_1 = require("../../../theme/global/palette");
var shadows_1 = require("../../global/shadows");
exports.MuiMenu = {
    paper: {
        borderRadius: shape_1.shape.borderRadius,
        padding: 0,
        boxShadow: shadows_1.boxShadow.medium,
    },
    list: {
        color: palette_1.palette.common.black,
    },
};
